<script setup>
/**
 * Styled HTML table wrapper with optional borders, separators, and dense mode.
 *
 * @status internal
 * @group lists-tables
 * @see https://quasar.dev/vue-components/markup-table Quasar q-markup-table API
 */
defineOptions({ name: 'HrMarkupTable' });

defineProps({
  /** Reduces row height to the dense density level. */
  dense: {
    type: Boolean,
    default: false,
  },
  /** Removes the card shadow, rendering the table on a flat surface. */
  flat: {
    type: Boolean,
    default: false,
  },
  /** Renders a border around the table. */
  bordered: {
    type: Boolean,
    default: false,
  },
  /**
   * Cell divider style.
   * @values horizontal, vertical, cell, none
   */
  separator: {
    type: String,
    default: 'horizontal',
    validator: (v) => ['horizontal', 'vertical', 'cell', 'none'].includes(v),
  },
  /** When true, cell content wraps instead of being truncated. */
  wrapCells: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="hr-markup-table">
    <q-markup-table v-bind="{ ...$props, ...$attrs }">
      <!-- @slot default Table content — thead and tbody elements. -->
      <slot />
    </q-markup-table>
  </div>
</template>

<style lang="scss" scoped>
.hr-markup-table :deep(.q-markup-table) {
  background: transparent;
  color: inherit;
}

.hr-markup-table :deep(th) {
  font-size: var(--app-type-title-small-size);
  line-height: var(--app-type-title-small-line-height);
  font-weight: var(--app-type-title-small-weight);
  letter-spacing: var(--app-type-title-small-tracking);
  color: inherit;
}
</style>
